import type { LoginResponse } from '../types/session';

export const login = async (email: string, password: string, redirectUrl: string, csrfToken: string): Promise<LoginResponse> => {
  const response = await fetch('/api/v1/sessions/create', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    body: JSON.stringify({ email, password, redirect_url: redirectUrl }),
    credentials: 'same-origin',
  });
  return await response.json();
};
